/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ImplantCategory } from 'app/shared/model/enumerations/implant-category.model';
import { ImplantType } from 'app/shared/model/enumerations/implant-type.model';
import { createEntity, getEntity, reset, updateEntity } from './implant-group.reducer';

export const ImplantGroupUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const implantGroupEntity = useAppSelector(state => state.implantGroup.entity);
  const loading = useAppSelector(state => state.implantGroup.loading);
  const updating = useAppSelector(state => state.implantGroup.updating);
  const updateSuccess = useAppSelector(state => state.implantGroup.updateSuccess);
  const implantCategoryValues = Object.keys(ImplantCategory);
  const implantTypeValues = Object.keys(ImplantType);

  const handleClose = () => {
    navigate(`/implant-group${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...implantGroupEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          category: 'CARDIOVASCULAR',
          type: 'ELECTIVE',
          ...implantGroupEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.implantGroup.home.createOrEditLabel" data-cy="ImplantGroupCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.implantGroup.home.createOrEditLabel">Create or edit a ImplantGroup</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="implant-group-id"
                  label={translate('tinyMedicRestApp.implantGroup.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.category')}
                id="implant-group-category"
                name="category"
                data-cy="category"
                type="select"
              >
                {implantCategoryValues.map(implantCategory => (
                  <option value={implantCategory} key={implantCategory}>
                    {translate(`tinyMedicRestApp.ImplantCategory.${implantCategory}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.type')}
                id="implant-group-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {implantTypeValues.map(implantType => (
                  <option value={implantType} key={implantType}>
                    {translate(`tinyMedicRestApp.ImplantType.${implantType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.addedBy')}
                id="implant-group-addedBy"
                name="addedBy"
                data-cy="addedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.deviceTypeName')}
                id="implant-group-deviceTypeName"
                name="deviceTypeName"
                data-cy="deviceTypeName"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.riskClass')}
                id="implant-group-riskClass"
                name="riskClass"
                data-cy="riskClass"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.generalIntendedUse')}
                id="implant-group-generalIntendedUse"
                name="generalIntendedUse"
                data-cy="generalIntendedUse"
                type="text"
                validate={{
                  maxLength: { value: 3000, message: translate('entity.validation.maxlength', { max: 3000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.timestampentry')}
                id="implant-group-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.active')}
                id="implant-group-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.lastupdated')}
                id="implant-group-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.cursor')}
                id="implant-group-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.implantGroup.microSec')}
                id="implant-group-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/implant-group" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ImplantGroupUpdate;
